import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
import Menu from "@/views/Menu.vue";
import Order from "@/views/Order.vue";
import Payment from "@/views/Payment.vue";
import Combo from "@/views/Combo.vue";
import Lock from "@/views/Lock.vue";
import Checkout from "@/views/Checkout";
import Numpad from "@/views/Numpad";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/numpad",
    name: "numpad",
    component: Numpad
  },
  {
    path: "/checkout",
    name: "checkout",
    component: Checkout
  },
  {
    path: "/order",
    name: "order",
    component: Order
  },
  {
    path: "/payment",
    name: "payment",
    component: Payment
  },
  {
    path: "/combo",
    name: "combo",
    component: Combo
  },
  {
    path: "/menu",
    name: "menu",
    component: Menu
  },
  {
    path: "/lock",
    name: "lock",
    component: Lock
  },
  {
    path: "*",
    redirect: "/"
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
